import React from "react"

interface DeleteWarningGauntletProps {
  subject: string
  children: React.ReactNode
}

// Wraps a destructive delete button in a long stretch of playful
// "are you sure" copy, so accidentally scrolling to (and clicking) the
// button takes real, deliberate effort.
export const DeleteWarningGauntlet: React.FC<DeleteWarningGauntletProps> = ({
  subject,
  children,
}) => (
  <div>
    <p className="mt-32 text-center text-gray-500 italic">
      Sure you want to delete {subject}? Keep scrolling!
    </p>
    <p className="mt-32 text-center text-gray-500 italic">
      Still sure? Almost there...
    </p>
    <p className="mt-32 text-center text-gray-500 italic">
      Okay, last chance to change your mind...
    </p>
    <div className="mt-32">{children}</div>
  </div>
)
